/**
 * Utility per la formattazione dei prezzi in formato italiano
 * Usa il simbolo € con virgola come separatore decimale
 * Es: 5.97 -> "5,97 €"
 */

const italianFormatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formatta un valore numerico come prezzo in formato italiano
 * @param {number} value - Il valore numerico da formattare
 * @returns {string} - Il prezzo formattato (es. "5,97 €")
 */
export const formatPrice = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '—';
  }
  return italianFormatter.format(value);
};

/**
 * Formatta un prezzo al chilogrammo
 * @param {number} value - Il valore numerico da formattare
 * @returns {string} - Il prezzo formattato con /kg (es. "33,33 €/kg")
 */
export const formatPricePerKg = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '—';
  }
  return `${italianFormatter.format(value)}/kg`;
};

/**
 * Formatta un prezzo con indicazione grammi
 * @param {number} value - Il valore numerico da formattare
 * @param {number} grams - I grammi (default 300)
 * @returns {string} - Il prezzo formattato (es. "10,00 € / 300g")
 */
export const formatPriceWithGrams = (value, grams = 300) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '—';
  }
  return `${italianFormatter.format(value)} / ${grams}g`;
};

export default formatPrice;
